module.exports = __webpack_public_path__ + "img/setting-s.59d894e0.svg";